import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";
import { showAccessDeniedModal } from "../slices/authSlice";

const getStore = () => require("../store").store;

export const TAXONOMIES_API_REDUCER_KEY = "taxonomiesApi";

export const taxonomiesApi = createApi({
  reducerPath: TAXONOMIES_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["org-taxonomies"],
  endpoints: (builder) => ({
    getTaxonomies: builder.query({
      query: () => {
        return {
          url: `/taxonomies/?limit=${100}`,
        };
      },
      providesTags: ["org-taxonomies"],
    }),
    getTaxonomiesHierarchy: builder.query({
      query: () => {
        return {
          url: `/taxonomies/hierarchy/`,
        };
      },
      providesTags: ["org-taxonomies"],
    }),

    getTaxonomy: builder.query({
      query: (id) => {
        if (!id) {
          return;
        }
        return {
          url: `/taxonomies/${id}/`,
        };
      },
      providesTags: ["org-taxonomies"],
    }),

    getSamplefile: builder.query({
      query: () => {
        return {
          url: `/emissions/base-matrics-sample/`,
          headers: {
            accept: `*/*`,
          },
          responseType: "blob",
        };
      },
      invalidatesTags: ["org-taxonomies"],
    }),

    createTaxonomy: builder.mutation({
      query: (body) => ({
        url: `/taxonomies/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["org-taxonomies"],
    }),
    updateTaxonomy: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `/taxonomies/${id}/`,
        method: "PATCH",
        body: rest,
      }),
      invalidatesTags: ["org-taxonomies"],
    }),

    deleteTaxonomy: builder.mutation({
      query: (id) => {
        return {
          url: `/taxonomies/${id}/`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["org-taxonomies"],
    }),
    getCategoryList: builder.query({
      query: () => {
        return {
          url: `/emissions/emission-categories/?page=1&limit=100`,
        };
      },
    }),

    getNodeEmissions: builder.query({
      query: ({ nodeId, startDate, endDate, depth = 1 } = {}) => {
        const params = new URLSearchParams();
        if (nodeId !== undefined && nodeId !== null) params.append('node_id', nodeId);
        if (startDate) params.append('start_date', startDate);
        if (endDate)   params.append('end_date',   endDate);
        params.append('depth', depth);
        return { url: `/ghgdashboard/node_emissions/?${params.toString()}` };
      },
    }),
  }),
});

export const {
  useCreateTaxonomyMutation,
  useGetTaxonomiesHierarchyQuery,
  useGetTaxonomiesQuery,
  useGetTaxonomyQuery,
  useLazyGetSamplefileQuery,
  useDeleteTaxonomyMutation,
  useUpdateTaxonomyMutation,
  useGetCategoryListQuery,
  useGetNodeEmissionsQuery,
} = taxonomiesApi;
